import { render, staticRenderFns } from "./ddo-report-view.vue?vue&type=template&id=15c79db3"
import script from "./ddo-report-view.vue?vue&type=script&lang=js"
export * from "./ddo-report-view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports